import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "styled-components";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { customImageLoader, getAssetSrc, useStaticImage, useResponsiveBreakPoints } from '@restworld/utils-common';
import { ImpressionIllustration, Title } from '../../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FrontViewImpressionTextSearchbox = function FrontViewImpressionTextSearchbox(_ref) {
  var children = _ref.children,
      algoliaSearchBarElement = _ref.algoliaSearchBarElement;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ImpressionTextEl, {
        children: children
      })
    }), algoliaSearchBarElement]
  });
};
export var MobileVersionFrontViewImpressionIllust = function MobileVersionFrontViewImpressionIllust() {
  return /*#__PURE__*/_jsx(_StyledDiv2, {
    children: /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(TopImpressionLogoEl, {}), /*#__PURE__*/_jsx(_StyledDiv4, {
        children: /*#__PURE__*/_jsx(ImpressionImage, {})
      })]
    })
  });
};
export var ImpressionTextEl = function ImpressionTextEl(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(_StyledDiv5, {
    children: children
  });
};
export var TopImpressionLogoEl = function TopImpressionLogoEl() {
  var _useTranslation = useTranslation('home-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_StyledDiv6, {
    children: [/*#__PURE__*/_jsx(Title, {
      textColor: "gray",
      fontSize: "base",
      twStyle: {
        "lineHeight": "1.5rem"
      },
      children: t('relay_on_us')
    }), /*#__PURE__*/_jsxs(_StyledDiv7, {
      children: [/*#__PURE__*/_jsx(_StyledImage, {
        src: getAssetSrc('/utils-assets/miscusi.svg'),
        width: "130",
        height: "64",
        loader: customImageLoader,
        alt: "top-impression-logos"
      }), /*#__PURE__*/_jsx(_StyledImage2, {
        src: getAssetSrc('/utils-assets/burger-king.svg'),
        width: "120",
        height: "64",
        loader: customImageLoader,
        alt: "top-impression-logos"
      }), /*#__PURE__*/_jsx(_StyledImage3, {
        src: getAssetSrc('/utils-assets/lavazza.svg'),
        width: "130",
        height: "64",
        loader: customImageLoader,
        alt: "top-impression-logos"
      })]
    })]
  });
};
export var ImpressionImage = function ImpressionImage() {
  var heroImg = useStaticImage('hero', getAssetSrc('/utils-assets/home-page/chef-with-wine.png'));
  return /*#__PURE__*/_jsxs(ImpressionIllustration, {
    variant: "mobileImageOverlay",
    children: [/*#__PURE__*/_jsx(_StyledDiv8, {
      children: /*#__PURE__*/_jsx(_StyledImage4, _objectSpread(_objectSpread({}, heroImg), {}, {
        alt: "hero",
        loader: customImageLoader,
        height: "400",
        width: "400"
      }))
    }), /*#__PURE__*/_jsx(_StyledDiv9, {
      children: /*#__PURE__*/_jsx(_StyledImage5, _objectSpread(_objectSpread({}, heroImg), {}, {
        alt: "hero",
        loader: customImageLoader,
        fill: true
      }))
    })]
  });
};
export var HomePageNavbarTitleContent = function HomePageNavbarTitleContent() {
  var _useTranslation2 = useTranslation('home-page'),
      t = _useTranslation2.t;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  return /*#__PURE__*/_jsxs(_StyledDiv10, {
    children: [/*#__PURE__*/_jsx(Title, {
      content: t('how_is_it_going'),
      textColor: isDesktop ? 'gray' : 'primary-50',
      fontSize: "large",
      fontWeight: "medium",
      twStyle: {
        "lineHeight": "1.688rem"
      }
    }), /*#__PURE__*/_jsxs(_StyledDiv11, {
      children: [/*#__PURE__*/_jsx(Title, {
        content: t('search_for_yours'),
        textColor: isDesktop ? 'black' : 'white',
        fontSize: "text-4xl",
        fontWeight: "semibold",
        twStyle: {
          "lineHeight": "2.273rem"
        }
      }), /*#__PURE__*/_jsx(Title, {
        content: t('ideal_job'),
        textColor: isDesktop ? 'bold-purple' : 'secondary',
        fontSize: "text-4xl",
        fontWeight: "semibold",
        twStyle: {
          "lineHeight": "2.273rem"
        }
      }), /*#__PURE__*/_jsx(Title, {
        content: t('today'),
        textColor: isDesktop ? 'black' : 'white',
        fontSize: "text-4xl",
        fontWeight: "semibold",
        twStyle: {
          "lineHeight": "2.273rem"
        }
      })]
    })]
  });
};
export var NavbarHomeTitleContent = function NavbarHomeTitleContent() {
  var _useTranslation3 = useTranslation('home-page'),
      t = _useTranslation3.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(_StyledH, {
      children: [t('meeting_point'), " ", /*#__PURE__*/_jsx(_StyledSpan, {
        children: t('catering')
      })]
    }), /*#__PURE__*/_jsxs(_StyledP, {
      children: [t('find_job_in_horeca'), /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("span", {
        children: t('start_professional_career')
      })]
    }), /*#__PURE__*/_jsxs(_StyledP2, {
      children: [t('find_job_in_horeca'), " ", t('start_professional_career')]
    })]
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv",
  componentId: "sc-1ji69ms-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "2rem",
  "padding": "1.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv2",
  componentId: "sc-1ji69ms-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "paddingBottom": "3rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv3",
  componentId: "sc-1ji69ms-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "2rem",
  "@media (min-width: 768px)": {
    "alignItems": "center"
  }
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv4",
  componentId: "sc-1ji69ms-3"
})({
  "height": "437px",
  "width": "100%",
  "@media (min-width: 768px)": {
    "@media (min-width: 768px)": {
      "width": "327px"
    }
  }
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv5",
  componentId: "sc-1ji69ms-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv6",
  componentId: "sc-1ji69ms-5"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "alignItems": "center"
  },
  "@media (min-width: 1024px)": {
    "alignItems": "flex-start"
  }
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv7",
  componentId: "sc-1ji69ms-6"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0px"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "impression-component___StyledImage",
  componentId: "sc-1ji69ms-7"
})({
  "opacity": "0.5",
  "--tw-saturate": "saturate(.25)",
  "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
});

var _StyledImage2 = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "impression-component___StyledImage2",
  componentId: "sc-1ji69ms-8"
})({
  "opacity": "0.5",
  "--tw-saturate": "saturate(.25)",
  "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
});

var _StyledImage3 = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "impression-component___StyledImage3",
  componentId: "sc-1ji69ms-9"
})({
  "opacity": "0.5",
  "--tw-saturate": "saturate(.25)",
  "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv8",
  componentId: "sc-1ji69ms-10"
})({
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});

var _StyledImage4 = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "impression-component___StyledImage4",
  componentId: "sc-1ji69ms-11"
})({
  "borderRadius": "20px"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv9",
  componentId: "sc-1ji69ms-12"
})({
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});

var _StyledImage5 = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "impression-component___StyledImage5",
  componentId: "sc-1ji69ms-13"
})({
  "borderRadius": "20px"
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv10",
  componentId: "sc-1ji69ms-14"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 1024px)": {
    "alignItems": "center",
    "justifyContent": "center"
  }
});

var _StyledDiv11 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-component___StyledDiv11",
  componentId: "sc-1ji69ms-15"
})({
  "display": "flex",
  "flexShrink": "0",
  "flexDirection": "column",
  "gap": "0.25rem",
  "@media (min-width: 1024px)": {
    "flexDirection": "row"
  }
});

var _StyledH = /*#__PURE__*/_styled("h1").withConfig({
  displayName: "impression-component___StyledH",
  componentId: "sc-1ji69ms-16"
})({
  "fontSize": "2.5rem",
  "lineHeight": "3rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "3.75rem",
    "lineHeight": "4.538rem",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  }
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "impression-component___StyledSpan",
  componentId: "sc-1ji69ms-17"
})({
  "--tw-text-opacity": "1",
  "color": "rgb(221 238 52 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "--tw-text-opacity": "1",
    "color": "rgb(142 105 206 / var(--tw-text-opacity))"
  }
});

var _StyledP = /*#__PURE__*/_styled("p").withConfig({
  displayName: "impression-component___StyledP",
  componentId: "sc-1ji69ms-18"
})({
  "display": "none",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "display": "block",
    "fontSize": "1.25rem",
    "lineHeight": "1.875rem",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  }
});

var _StyledP2 = /*#__PURE__*/_styled("p").withConfig({
  displayName: "impression-component___StyledP2",
  componentId: "sc-1ji69ms-19"
})({
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "display": "none",
    "fontSize": "1.25rem",
    "lineHeight": "1.875rem",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  }
});